import { IGetTermosDropDownUseCase } from "../../../presentation/useCases/read/get_termos_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";


/**
 * GetTermosDropDownUseCase
 */

export class GetTermosDropDownUseCase implements IGetTermosDropDownUseCase {
    constructor(private readonly repository: ICommonsRepository) { }

    async getTermosDropDown(): Promise<DropDown[]> {
        return await this.repository.getTermosDropDown();
    }

}
